import MxCheck, { MxCheckProps } from "@rf-l1/form/MxCheck";
import { useMxFieldControllerContext } from "@rf/context/MxFieldController";
import React from "react";

type omit = "name" | "value" | "onChange";
export type MxFormCheckFieldProps = Omit<MxCheckProps, omit>
const MxFormCheckField = (props: MxFormCheckFieldProps) => {
  const { onBlur, onChange, inputRef, name, value, invalid, disabled } =
    useMxFieldControllerContext();

  const onHandleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    onBlur(e);
    if (props.onBlur) {
      props.onBlur?.(e);
    }
  };

  return (
    <MxCheck
      {...props}
      onBlur={onHandleBlur}
      name={name}
      onChange={onChange}
      inputRef={inputRef}
      value={value}
      invalid={invalid}
    />
  );
};

export default MxFormCheckField;
